import Technology from "../catalog/Catalog";

const TabletsPage = () => {
  const headline = 'Tablets';
  const title = 'Tablets';

  return (
    <Technology headline={headline} title={title} />  
  );
};

export default TabletsPage;